import React, { Component } from 'react';
import './About.css';
import gregAbout from '../../Assets/gregAbout.jpg';
import loganAbout from '../../Assets/loganAbout.jpg';
import { BrowserRouter as Router, Routes,Route } from 'react-router-dom';


class About extends Component {
  render() {
  return (
    <div class='aboutMain'>
      <div class='aboutHeader'>
        <h1 class="aboutTitle">
          About Us
        </h1>
      </div>
      <div class="visionSect">
         <h2>Local Family Owned and Operated Business</h2>
         <div class="vision">
          Our Vision at DNS Home Exteriors has always been to set a new standard of excellence for contractors that raises the bar when it comes to first-class customer service, industry knowledge, and craftsmanship.
         </div>
      </div>
      <hr></hr>
      <div class="aboutCardsSect">
        <section class="aboutCard">
          <img className="about-img" src={loganAbout} alt=""/>
          <div>
          <h4>Logan Gappa</h4>
          <p>Hello, I have been working in construction for 15 years. I was born in Denver and have lived here all my life. I enjoy spending time in the outdoors camping, fishing, and hiking. I look forward to working with you and helping make your dream home come true. Feel free to contact me at loganwdns@gmail.com.</p>
          </div>
        </section>
        <section class="aboutCard">
          <img className="about-img" src={gregAbout} alt=""/>
          <div>
            <h4>Greg Gappa</h4>
            <p>Hello, I was born in Aurora and have lived here my entire life, and have enjoyed raising my family here. I have been in construction for 32 years. I enjoy playing with my grandkids, reading, kayaking, and camping. I can't wait to hear from you to begin the process of making your home the best on the block. Feel free to contact me at gregwdns@gmail.com</p>
          </div>
        </section>
      </div>
    </div>
  )
};
}

export default About;
